import React from "react";
import StatusBadge from "../components/StatusBadge";
import Table from "../components/Table";
import TitleBar from "../components/TitleBar";
import HeaderPanel from "../components/HeaderPanel";
import RaisedButton from "../components/RaisedButton";
import InnerBody from "../components/InnerBody";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import withAuthorization from "../firebase/withAuthorization";
import AddProjectDialog from "../components/AddProjectDialog";
import { listProjects, getClientUpdates } from "../firebase/firestore";
import { dateToStringShort } from "../utils/DateHelper";
import withAccount from "../utils/withAccount";

class PageProjects extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      clientId: this.props.match.params.clientId,
      client: {},
      clients: [],
      projects: [],
      addProjectDialogVisible: false
    };

    this.clientsListenerUnsub = null;
  }

  componentDidMount() {
    const { account } = this.props;
    this.clientsListenerUnsub = getClientUpdates(account.id, docs => {
      let clients = [];

      docs.forEach(element => {
        let data = element.data();
        clients.push({
          id: element.id,
          name: data.name,
          created: data.created,
          logoUrl: data.logo_url,
          status: ""
        });
      });

      this.setState({ clients: clients, isLoading: false });
      this.fetchData(this.props.match.params.clientId);
    });
  }

  componentWillUnmount() {
    if (this.clientsListenerUnsub) this.clientsListenerUnsub();
  }

  validateClient(clientId, clients) {
    let valid = false;
    for (var i = 0; i < clients.length; i++) {
      if (clients[i].id === clientId) {
        valid = true;
        const c = clients[i];
        if (this.state.client !== c) this.setState({ client: c });
        break;
      }
    }

    if (!valid && clients.length > 0) {
      this.props.history.push(`projects/${clients[0].id}`);
    }
  }

  componentWillReceiveProps(newProps, newState) {
    this.setState({
      clientId: newProps.match.params.clientId
    });
    this.fetchData(newProps.match.params.clientId);
  }

  fetchData(_c) {
    const { account } = this.props;
    let { clientId } = this.state;

    if (_c !== undefined) clientId = _c;

    if (!this.isValidClient(clientId)) return;

    this.setState({ isLoading: true });

    listProjects(
      account.id,
      clientId,
      query => {
        let projects = [];
        query.forEach(doc => {
          const data = doc.data();
          projects.push({
            id: doc.id,
            name: data.name,
            status: data.status,
            created: data.timestamp,
            updated: data.lastUpdate
          });
        });
        this.setState({ isLoading: false, projects: projects });
      },
      error => {
        console.log(error);
      }
    );
  }

  createProjectsDataArray() {
    let data = [];
    this.state.projects.forEach(p => {
      let dateUpdated;
      let dateCreated = dateToStringShort(p.created.toDate());

      if (p.updated !== undefined)
        dateUpdated = dateToStringShort(p.updated.toDate());
      else dateUpdated = dateCreated;

      data.push({
        items: [
          p.name,
          dateUpdated,
          <StatusBadge status={p.status} />,
          dateCreated
        ]
      });
    });

    return data;
  }

  isValidClient(clientId) {
    const { clients } = this.state;
    for (var i = 0; i < clients.length; i++) {
      if (clients[i].id === clientId) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { clientId, clients, client } = this.state;

    this.validateClient(clientId, clients);

    return (
      <div>
        <Header
          title="Projekte"
          showProjectsDropdown={true}
          selectedClientId={this.state.clientId}
          clientChangeable={true}
          showProfile={true}
          clients={clients}
        />
        <NavigationSideBar page="projects" />
        {this.isValidClient(this.state.clientId) ? (
          <InnerBody isLoading={this.state.isLoading}>
            <HeaderPanel client={client} account={this.props.account} />
            <TitleBar title="Projekte">
              <RaisedButton
                label="Projekt Erstellen"
                onClick={() => {
                  this.setState({ addProjectDialogVisible: true });
                }}
              />
            </TitleBar>
            <Table
              header={[
                {
                  items: [
                    "Projekt-Name",
                    "Letzte Aktualisierung",
                    "Status",
                    "Erstellt"
                  ]
                }
              ]}
              onItemSelected={index => {
                const clientId = this.state.clientId;
                const projectId = this.state.projects[index].id;
                this.props.history.push(`${clientId}/manage/${projectId}`);
              }}
              data={this.createProjectsDataArray()}
            >
              Sie haben noch kein Projekt, für diesen Kunden, erstellt.
            </Table>
          </InnerBody>
        ) : (
          <InnerBody isLoading={this.state.isLoading}>
            <p>Kein Kunde ausgewählt</p>
          </InnerBody>
        )}

        <AddProjectDialog
          account={this.props.account}
          client={this.state.clientId}
          history={this.props.history}
          visible={this.state.addProjectDialogVisible}
          onClose={() => this.setState({ addProjectDialogVisible: false })}
        />
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageProjects));



// WEBPACK FOOTER //
// ./src/pages/PageProjects.js